import React, {useEffect, useRef, useState} from "react";
import SidebarNav from "../Sidebar/SidebarNav.js";
import {useNavigate, useParams} from 'react-router-dom';
import {FaSort, FaSortUp, FaSortDown} from "react-icons/fa";
import ModalTask from "./ModalTask.js";
import projectsService from "../../../services/projectsService.js";
import activitiesService from "../../../services/activitiesService.js";
import TasksPartialRowItems from "./TasksPartialRowItems.js";
import LoadingContent from "../../public/LoadingContent.js";
import TasksPartialTableFilterBar from "./TasksPartialTableFilterBar.js";
import TasksPartialPager from "./TasksPartialPager.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import utilsHelper from "../../../helpers/utilsHelper.js";

const Tasks = () => {
    const didFetchProjects = useRef(false);
    const didFetchContent = useRef(false);
    const {projectId} = useParams();
    const tasksPerPage = 10;
    const titleSingular = 'Actividad';
    const titlePlural = 'Actividades';
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataProjects, setDataProjects] = useState([]);
    const [dataUsersOwner, setDataUsersOwner] = useState([]);
    const [currentProjectName, setCurrentProjectName] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingModal, setEditingModal] = useState(false);
    const [parentTaskId, setParentTaskId] = useState("");
    const [expandedTasks, setExpandedTasks] = useState({});
    const [loadingGrid, setLoadingGrid] = useState(true);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filter, setFilter] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalTasks, setTotalTasks] = useState(0);
    const [sortConfig, setSortConfig] = useState({ key: "created_at", direction: false });
    const columns = [
        { key: "created_at", label: "Creado" },
        { key: "name", label: "Nombre" },
        { key: "status_id", label: "Estado" },
        { key: "estimated_start", label: "Inicio" },
        { key: "estimated_end", label: "Término" },
        { key: "created_by_user_id", label: "Creado por" },
        { key: "task_assigns", label: "Asignados", sortable: false },
    ];

    const handleDownloadPdf = async () => {
        const doc = new jsPDF();
        const logo = await utilsHelper.convertImageToBase64("/logo-rcj.png");
        const colorHeader = '#2c3e50';

        doc.addImage(logo, "PNG", 14, 10, 30, 15);
        doc.setFontSize(16);
        doc.text(`Actividades de ${currentProjectName}`, 50, 20);

        const tableColumn = [
            "Actividad",
            "Estado",
            "Inicio",
            "Término",
            "Creado",
            "Creado por"
        ];

        const tableRows = [];

        const flattenTasks = (tasks) => {
            const result = [];
            tasks.forEach(task => {
                result.push(task);
                if (task.subtasks && task.subtasks.length > 0) {
                    result.push(...flattenTasks(task.subtasks));
                }
            });
            return result;
        };

        const allTasks = flattenTasks(data);

        allTasks.forEach(task => {
            const row = [
                task.name || '',
                task.status?.name || 'Pendiente de aprobación',
                utilsHelper.formatDate(task.estimated_start, false) || '',
                utilsHelper.formatDate(task.estimated_end, false) || '',
                utilsHelper.formatDate(task.created_at, true) || '',
                task.created_by_user?.name || ''
            ];
            tableRows.push(row);
        });

        autoTable(doc, {
            startY: 30,
            head: [tableColumn],
            body: tableRows,
            styles: { fontSize: 9 },
            headStyles: {
                fillColor: utilsHelper.hexToRgb(colorHeader),
                textColor: 255,
                fontStyle: 'bold',
            },
        });

        doc.save(`actividades_${currentProjectName || 'sin_nombre'}.pdf`);
    };


    const handleSort = (key) => {
        setSortConfig((prev) => {
            const direction = prev.key === key && prev.direction === "asc" ? "desc" : "asc";
            const newConfig = { key, direction };
            loadContent(key, direction, filter, 1);
            return newConfig;
        });
    };

    const loadContentWithFilters = (filter, page) => {
        setSortConfig({ key: "created_at", direction: "asc" });
        setFilter(filter);
        loadContent(sortConfig.key, filter, page);
    }

    const loadPageChange = (page) => {
        setCurrentPage(page);
        loadContent(sortConfig.key, sortConfig.direction, filter, page);
    }

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return <FaSort />;
        if (sortConfig.direction === "asc") return <FaSortUp />;
        if (sortConfig.direction === "desc") return <FaSortDown />;
        return <FaSort />;
    };

    const loadContent = (key = "created_at", direction = "asc", filter = {}, page = 1) => {
        setLoadingGrid(true);
        setLoading(true);

        let sortedBy = key;
        let sortedAsc = false;
        if(sortConfig.key != null){
            sortedBy = sortConfig.key;
        }
        if(sortConfig.direction != null){
            sortedAsc = sortConfig.direction === "asc";
        }

        activitiesService.getActivities(projectId, sortedBy, sortedAsc, filter, page, tasksPerPage).then(data => {
            setTotalTasks(data.total);
            data = data.tasks;
            data = RestructureTasks(data);
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    if(data[i].project.id === projectId) {
                        setCurrentProjectName(data[i].project.project_name);
                        break;
                    }
                }
                for (let i = 0; i < data.length; i++) {
                    let add = true;
                    if (dataUsersOwner.length > 0){
                        dataUsersOwner.forEach(user => {
                            if (user.id === data[i].created_by_user.id) {
                                add = false;
                            }
                        });
                    }
                    if (add) {
                        let tmpDataUsersOwner = dataUsersOwner;
                        tmpDataUsersOwner.push({
                            id: data[i].created_by_user.id,
                            name: data[i].created_by_user.name,
                        });
                        setDataUsersOwner(tmpDataUsersOwner);
                        tmpDataUsersOwner = null;
                    }
                }
            }
            setData(data);
            setLoadingGrid(false);
            setLoading(false);
        });
    }

    const RestructureTasks = (tasks) => {
        const tasksById = {};

        if (tasks != null) {
            if (tasks.length > 0) {
                tasks.forEach(task => {
                    tasksById[task.id] = { ...task, subtasks: [] };
                });
            }
        }

        const rootTasks = [];

        if (tasks != null) {
            if (tasks.length > 0) {
                tasks.forEach(task => {
                    if (task.parent_task_id) {
                        const parentTask = tasksById[task.parent_task_id];
                        if (parentTask) {
                            parentTask.subtasks.push(tasksById[task.id]);
                        }
                    } else {
                        rootTasks.push(tasksById[task.id]);
                    }
                });
            }
        }

        return rootTasks;
    }

    const loadProjects = () => {
        projectsService.getProjects().then(data => {
            if (data && data.length > 0) {
                setDataProjects(data);
            }
        });
    }

    const goToActivity = (id) => {
        navigate(`/actividad/${id}`);
    }

    const handleNewActivity = () => {
        setEditingModal(false);
        setIsModalOpen(true);
    }

    const handleOpenModalForEdit = (data) => {
        setEditingModal(data);
        setIsModalOpen(true);
    }

    const handleDelete = (id) => {
        if(window.confirm("¿Estás seguro que deseas eliminar esta tarea?")){
            activitiesService.deleteActivity(id).then(() => {
                loadContent("created_at");
            });
        }
    }

    const toggleExpand = (id) => {
        setExpandedTasks(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    useEffect(() => {
        const today = new Date();
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 5, 1);

        const start_date = firstDayLastMonth.toISOString().split("T")[0];
        setStartDate(start_date);

        if (!didFetchProjects.current) {
            didFetchProjects.current = true;
            loadProjects();
        }
    }, []);

    useEffect(() => {
        if (startDate && filter && currentPage) {
            const filters = {
                ...filter,
                estimated_start: startDate,
            };
            if (!didFetchContent.current) {
                didFetchContent.current = true;
                loadContent("created_at", filters, currentPage);
            }
        }
    }, [startDate, endDate, filter, currentPage, loadContent]);

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row vh-100">

                <SidebarNav/>

                {isModalOpen && (
                    <ModalTask
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        editingModal={editingModal}
                        loadContent={loadContent}
                        titleSingular={titleSingular}
                        dataProjects={dataProjects}
                        parentTaskId={parentTaskId}
                        projectId={projectId}
                    />
                )}

                <div className="col-md-9 col-lg-10 p-4 content-container">

                    {loading && (
                        <LoadingContent/>
                    )}

                    {!loading && (
                        <div>
                            <h3 className="mb-4">
                                <i className="bi bi-list-task"></i>&nbsp;
                                {currentProjectName && (
                                    <>
                                        {currentProjectName}
                                        <span> > </span>
                                    </>
                                )}
                                {titlePlural}
                            </h3>

                            <div className="row">
                                <div className="col">
                                    <div className="btn-group" role="group">
                                        <button className="btn btn-secondary mb-3"
                                                onClick={() => navigate(-1)}>
                                            <i className="bi bi-arrow-left"></i> Atrás
                                        </button>

                                        <button className="btn btn-success mb-3" onClick={handleNewActivity}>
                                            Crear nueva {titleSingular}
                                        </button>

                                        <button className="btn btn-danger mb-3" onClick={handleDownloadPdf}>
                                            <i className="bi bi-file-earmark-pdf me-2"></i>
                                            Descargar PDF
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{marginTop: '10px'}}>
                                <div className="col-md-12">
                                    <div className="bg-light rounded shadow-sm">

                                        {data.length > 0 && (
                                            <table className="table table-striped corner-radius">
                                                <thead>
                                                <TasksPartialTableFilterBar
                                                    columns={columns}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    dataUsersOwner={dataUsersOwner}
                                                    loadContentWithFilters={loadContentWithFilters}/>
                                                <tr>
                                                    <th></th>
                                                    {(typeof projectId === 'undefined') && (
                                                        <th>Programa</th>
                                                    )}
                                                    {columns.map((col) => (
                                                        <th key={col.key} style={{ whiteSpace: "nowrap" }}>
                                                            {col.sortable === false ? (
                                                                col.label
                                                            ) : (
                                                                <button
                                                                    onClick={() => handleSort(col.key)}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "4px",
                                                                        background: "none",
                                                                        border: "none",
                                                                        cursor: "pointer",
                                                                        fontWeight: sortConfig.key === col.key ? "bold" : "normal",
                                                                        color: sortConfig.key === col.key ? "#007bff" : "inherit"
                                                                    }}
                                                                >
                                                                    {col.label} {getSortIcon(col.key)}
                                                                </button>
                                                            )}
                                                        </th>
                                                    ))}
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {loadingGrid && (
                                                    <tr>
                                                        <td colSpan={columns.length+2}>
                                                            <LoadingContent/>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!loadingGrid && (
                                                    <>
                                                        {Array.isArray(data) && data.map((item, i) => {
                                                            let isExpired = false;
                                                            if (item.estimated_end != null){
                                                                const estimatedEndDate = new Date(item.estimated_end);
                                                                const today = new Date();
                                                                const isFinal = item.status?.is_final === true || item.is_final === true;
                                                                if (!isFinal && estimatedEndDate < today) {
                                                                    isExpired = true;
                                                                }
                                                            }

                                                            return (
                                                                <TasksPartialRowItems
                                                                    key={item.id}
                                                                    idented={false}
                                                                    item={item}
                                                                    isExpired={isExpired}
                                                                    toggleExpand={toggleExpand}
                                                                    expandedTasks={expandedTasks}
                                                                    goToActivity={goToActivity}
                                                                    handleOpenModalForEdit={handleOpenModalForEdit}
                                                                    handleDelete={handleDelete}
                                                                    projectId={projectId}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                )}

                                                <TasksPartialPager
                                                    currentPage={currentPage}
                                                    totalPages={Math.ceil(totalTasks / tasksPerPage)}
                                                    onPageChange={loadPageChange}/>

                                                </tbody>
                                            </table>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>

            </div>
        </div>
    );
}

export default Tasks;